import { Mail, ArrowUpRight } from "lucide-react";
import { TEST_IDS, PLATFORM_LINKS, ASSETS } from "@/constants/testIds";

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer
            data-testid={TEST_IDS.footer}
            className="bg-white border-t border-hairline"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 py-14 md:py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
                    {/* Brand */}
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3 mb-5">
                            <img
                                src={ASSETS.logoCircle}
                                alt="Southern African Traders Ltd logo"
                                className="h-10 w-10 rounded-full object-cover ring-1 ring-hairline"
                            />
                            <div className="leading-tight">
                                <div className="font-serif text-base font-semibold text-ink tracking-tight">
                                    Southern African Traders Ltd
                                </div>
                                <div className="text-[10px] tracking-[0.3em] uppercase text-muted2">
                                    Digital Ventures · UK
                                </div>
                            </div>
                        </div>
                        <p className="font-serif italic text-lg text-ink/85 max-w-md leading-snug">
                            Developing digital platforms for learning, dialogue, and
                            connection.
                        </p>
                    </div>

                    {/* Platforms */}
                    <div className="md:col-span-3">
                        <div className="text-[10px] tracking-[0.3em] uppercase text-muted2 mb-5">
                            Platforms
                        </div>
                        <ul className="space-y-3">
                            <li>
                                <a
                                    href={PLATFORM_LINKS.linguisticQuest}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={TEST_IDS.footerLinkLq}
                                    className="group inline-flex items-center gap-2 text-sm text-ink hover:text-navy transition-colors"
                                >
                                    Linguistic Quest
                                    <ArrowUpRight
                                        size={14}
                                        strokeWidth={1.5}
                                        className="opacity-60 group-hover:opacity-100 transition-opacity"
                                    />
                                </a>
                            </li>
                            <li>
                                <a
                                    href={PLATFORM_LINKS.playTsoro}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={TEST_IDS.footerLinkTsoro}
                                    className="group inline-flex items-center gap-2 text-sm text-ink hover:text-navy transition-colors"
                                >
                                    Play Tsoro
                                    <ArrowUpRight
                                        size={14}
                                        strokeWidth={1.5}
                                        className="opacity-60 group-hover:opacity-100 transition-opacity"
                                    />
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div className="md:col-span-4">
                        <div className="text-[10px] tracking-[0.3em] uppercase text-muted2 mb-5">
                            Contact
                        </div>
                        <a
                            href="mailto:info@satraders.co.uk"
                            data-testid={TEST_IDS.footerContactEmail}
                            className="group inline-flex items-center gap-2 font-serif text-xl md:text-2xl text-ink hover:text-navy transition-colors"
                        >
                            <Mail size={18} strokeWidth={1.5} />
                            info@satraders.co.uk
                        </a>
                        <div className="mt-3 text-sm text-muted2">
                            <a
                                href="https://www.satraders.co.uk"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:text-navy transition-colors"
                            >
                                www.satraders.co.uk
                            </a>
                        </div>
                    </div>
                </div>

                <div className="hairline my-12" />

                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-muted2">
                    <div>© {year} Southern African Traders Ltd. All rights reserved.</div>
                    <div className="tracking-[0.18em] uppercase text-[10px] text-muted2/80">
                        Registered in the United Kingdom
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
